import { useNavigate, Routes, Route, NavLink } from "react-router-dom";
import UsuarioId from "./usuario_id";
import Usuario from "./usuario";
import Lider from "./lider";


// import Cambio from '../logins/changePassword'
import InfoVotante from "./infoVotante";
import InfoLiderVotante from "./infoLiderVotantes";
import Perfil from "./perfil";
const Sidebar = () => {
  let history = useNavigate();
  const salir = () => {
    localStorage.removeItem("User");
    localStorage.removeItem("IsAdmin");
    history(`/`);
    window.location.reload();
  };
  return (
    <div className="fondo">
      <header
        id="nav__"
        className="navbar navbar-dark sticky-top  flex-md-nowrap p-0 shadow"
      >
        <NavLink
          className="navbar-brand col-md-3 col-lg-2 me-0 px-3 text-dark"
          to="/user"
        ></NavLink>
        <button
          onClick={salir}
          style={{ border: "none", background: "none", fontSize: "25px" }}
          className="text-dark nav-link px-3 power-si"
        >
          <i className="bi bi-power"></i>
        </button>
        <button
          className="navbar-toggler position-absolute d-md-none collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#sidebarMenu"
          aria-controls="sidebarMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="navbar-nav">
          <div className="nav-item text-nowrap power-none">
            <button
              onClick={salir}
              style={{ border: "none", background: "none", fontSize: "25px" }}
              className=" text-dark nav-link px-3"
            >
              <i className="bi bi-power"></i>
            </button>
          </div>
        </div>
      </header>

      <div className="container-fluid">
        <div className="row">
          <nav
            id="sidebarMenu"
            className="col-md-3 col-lg-2 d-md-block  sidebar collapse "
          >
            <div className="position-sticky pt-3">
              <ul className="nav flex-column">
                <li className="nav-item">
                  <NavLink to="/usuario" className="nav-link ">
                    Lista General Votantes
                    <i className="bi bi-person ml"></i>
                  </NavLink>
                </li>
                <li className="nav-item mt-2">
                  <NavLink to="/lideres" className="nav-link ">
                    Lista Lideres
                    <i className="bi bi-arrows-fullscreen ml"></i>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/perfil" className="nav-link ">
                    Perfiles
                    <i className="bi bi-person ml"></i>
                  </NavLink>
                </li>
{/* 
                <li className="nav-item mt-2">
                  <NavLink to="/reportes" className="nav-link ">
                    Reportes
                    <i className="bi bi-filetype-pdf ml"></i>
                  </NavLink>
                </li> */}
                
              
              </ul>
            </div>
          </nav>
          <div className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <Routes>
             
              <Route path="/usuario/:id" element={<UsuarioId />} exact />
             
         
              <Route path="/" element={<Usuario />} exact />
              <Route path="/info/:id" element={<InfoVotante />} exact />
              {/* <Route path="/cambio/pass" element={<Cambio/>} exact /> */}
              <Route path="/lider/votantes/:id" element={<InfoLiderVotante />} exact />
              <Route path="/usuario" element={<Usuario />} exact />
              <Route path="/lideres" element={<Lider />} exact />
              
              <Route path="/perfil" element={<Perfil />} exact />
              {/* <Route path="/reportes" element={<Reportes />} exact /> */}
             
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Sidebar;
